export const initDeviceUtils = () => {
  const handleUploadStartedFile = (imageInfo, type) => {
    if (type === 'damageImages') {
      return window.onDamageImagesUploadStarted?.(imageInfo) ?? false
    }
    if (type === 'inventoryImages') {
      return window.onInventoryImagesUploadStarted?.(imageInfo) ?? false
    }
  }

  const handleUploadFinishedFile = (imageInfo, type) => {
    if (type === 'damageImages') {
      return window.onDamageImagesUploadFinished?.(imageInfo) ?? false
    }
    if (type === 'inventoryImages') {
      return window.onInventoryImagesUploadFinished?.(imageInfo) ?? false
    }
  }

  const handleUploadFinishedAll = (data, type) => {
    if (type === 'damageImages') {
      return window.onDamageImagesUploadFinishedAll?.(data) ?? false
    }
    if (type === 'inventoryImages') {
      return window.onInventoryImagesUploadFinishedAll?.(data) ?? false
    }
  }

  window.uploadStartedFile = handleUploadStartedFile
  window.uploadFinishedFile = handleUploadFinishedFile
  window.uploadFinishedAll = handleUploadFinishedAll
}

export default initDeviceUtils
